import { useParams } from 'react-router'

const useFlowParam = () => {
  const { flow } = useParams<{ flow: string }>()

  if (!flow) {
    throw new Error('Flow is required')
  }

  return flow
}

export default useFlowParam
